

import { create } from "zustand";
import {
  persist,
  createJSONStorage,
  subscribeWithSelector,
} from "zustand/middleware";
import shellstoreState from "./shellStoreState";

const useStore = create(
  subscribeWithSelector(
    persist(
      (set, get) => ({
        ...shellstoreState(set, get),
        // Add other state properties and methods here
      }),
      {
        name: "shellStore", // Unique name for the storage
        storage: createJSONStorage(() => sessionStorage), // Use sessionStorege as the storage
      }
    )
  )
);

export default useStore;
